const BASE = process.env.REACT_APP_API_URL ?? "http://localhost:5000/api";

const authHeaders = (token: string) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

export interface HackathonPayload {
  title: string;
  organizerName: string;
  description: string;
  startDate: string;
  endDate: string;
  mode: string;
  themes: { title: string; description: string }[];
  prizes: { title: string; amount: number; currency: string }[];
  phases: {
    registration: { enabled: boolean; startDate: string; endDate: string };
    submission: {
      enabled: boolean;
      startDate: string;
      endDate: string;
      initialSubmissionStart: string;
      initialSubmissionEnd: string;
      finalSubmissionStart: string;
      finalSubmissionEnd: string;
      mentorReviewDays: number;
      ideaSelection: { panelId: null; decisionDeadline: string };
    };
    evaluation: {
      enabled: boolean;
      startDate: string;
      endDate: string;
      rounds: { order: number; name: string; type: string; startDate: string; endDate: string; panelId: null }[];
    };
  };
  rules?: { fileName: string; fileType: string; fileSize: number; fileUrl: string };
}

export async function createHackathon(token: string, payload: HackathonPayload) {
  const res = await fetch(`${BASE}/hackathon-events`, {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error ?? data.message ?? "Failed to create hackathon");
  return data;
}

export async function getHackathon(token: string, id: string) {
  const res = await fetch(`${BASE}/hackathon-events/${id}`, {
    method: "GET",
    headers: authHeaders(token),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error ?? data.message ?? "Failed to fetch hackathon");
  return data;
}

export async function updateHackathon(token: string, id: string, payload: Partial<HackathonPayload>) {
  const res = await fetch(`${BASE}/hackathon-events/${id}`, {
    method: "PATCH",
    headers: authHeaders(token),
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error ?? data.message ?? "Failed to update hackathon");
  return data;
}
